// Calcuates the width of an item so we can use a mask to fade out the edges
const setCarouselCssVar = (carousel) => {
  const slideWidth = carousel.querySelector('.splide__slide').clientWidth;
  carousel.parentElement.style.setProperty('--slideWidth', `${slideWidth}px`);
}

export { setCarouselCssVar }